import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { CommitteeService } from 'src/app/services/committee.service';
import { AlertComponent } from '../../alert/alert.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-committee',
  templateUrl: './committee.component.html',
  styleUrls: ['./committee.component.css']
})
export class CommitteeComponent implements OnInit {

  public environmentSettings: any;

  readonlyField: boolean = false;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  committeeForm: FormGroup;
  statutoryCommitteeModel: any;
  committeeName: any[];
  committeeData: any[];
  dtTrigger: Subject<any> = new Subject();
  committeeId: any;
  G_deletingID: any;
  dtOptions: DataTables.Settings = {};


  dtOptions2: DataTables.Settings = {};

  IsAuditCommitteeSelected: boolean;
  committeeNotSetUpList: any[];
  dateOfIncorpOfCompany: any;
  futureDate: any;
  disabledOnclick: boolean;
  fileExtension: boolean = true;
  changefileExtension: boolean = true;
  constructor(private commonFunction: CommonFunction,
    private customValidation: CustomValidation,
    private committeeService: CommitteeService,
    private router: Router,
    private alert: AlertComponent,
    private renderer: Renderer2,
    private route: ActivatedRoute
  ) { }


  ngOnInit() {

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
    this.environmentSettings = environment;

    var IsAuditCommitteeSelected = false
    this.readonlyField = false;
    this.getCommitteeList();
    // this.commonFunction.removeDataTableSaveStateKey("committeeTable");
    this.dtOptions = {
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      //order: list(list(2, 'asc'), list(4, 'desc')),
      columnDefs: [{ orderable: false, targets: [3] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    };
    var self = this;
    var token = localStorage.getItem('token')
    this.dtOptions2 = {
      ajax: {
        url: environment.pssServerUrl + "dataTable/committee/" + JSON.parse(localStorage.getItem("companyDetails")).companyID,
        type: 'get',
        headers: { "x-access-token": token },
      },
      columns: [{
        title: 'Committee',
        render: function (data: any, type: any, full: any) {
          if (full._id == null) {
            return '<div style="background-color: #f5f3c5;">' + full.CommitteeAlias + '<div>'
          } else {
            return full.CommitteeAlias
          }

        },
      }, {
        title: 'Statutory',
        render: function (data: any, type: any, full: any) {
          if (full._id == null && full.CommitteeName != "Other") {
            return 'Yes'
          } else {
            return full.SatutoryCommittee
          }
        }
      }, {
        title: 'Mandatory',
        render: function (data: any, type: any, full: any) {
          if (full.Mandatory && full.CommitteeName != "Other") {
            return full.Mandatory
          } else {
            return 'N/A'
          }
        }
      },
      {
        title: 'Date',
        render: function (data: any, type: any, full: any) {
          if (full._id == null) {
            return '<div style="background-color: #f5f3c5;">N/A<div>'
          } else {
            return '<span style="display:none">' + new Date(full.ActivationDate).getFullYear() + '' + (new Date(full.ActivationDate).getMonth() + 1) + '' + self.roundDigit(new Date(full.ActivationDate).getDate()) + '</span>' + self.roundDigit(new Date(full.ActivationDate).getDate()) + '-' + (new Date(full.ActivationDate).getMonth() + 1) + '-' + new Date(full.ActivationDate).getFullYear() + ''
          }
        }
      },
      {
        title: 'Action',
        render: function (data: any, type: any, full: any) {
          if (self.commonFunction.validateModulePermitions('Committee', '/committee/edit?goveva=true&email=')) {
            if (full._id == null) {
              return '<div style="background-color: #f5f3c5;"><button type="button" class="btn-sm btn btn-primary" setup-committee=' + full.CommitteeAlias + '> <span class="fa fa-wrench" setup-committee=' + full.CommitteeAlias.toString() + '></span></button><div>'
            } else {
              return '<button [appHasPermission]="{Url: /committee/edit?goveva=true&email=, method:put, menu: Committee}" type="button"  update-committee=' + full._id + ' class="btn-sm btn btn-warning" ><span class="fa fa-pencil"  update-committee=' + full._id + '></span></button>&nbsp;&nbsp;<button [appHasPermission]="{Url: /committee/edit?goveva=true&email=, method:put, menu: Committee}" type="button" delete-committee=' + full._id + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-committee=' + full._id + '></span></button>';
            }
          } else {
            return '';
          }
        }
      },
      {
        title: 'Date',
        render: function (data: any, type: any, full: any) {
          if (full._id == null) {
            return '<div style="background-color: #f5f3c5;">N/A<div>'
          } else {
            return '<span>' + self.roundDigit(new Date(full.ActivationDate).getDate()) + '-' + (new Date(full.ActivationDate).getMonth() + 1) + '-' + new Date(full.ActivationDate).getFullYear() + ''
          }
        }
      }],
      createdRow: function (node, data) {
        if (_.get(data, "_id") == null) {
          $(node).addClass('highlight-Committee');
        }
      },
      processing: true,
      serverSide: false,
      pagingType: 'full_numbers',
      pageLength: 10,
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      destroy: true,
      columnDefs: [{ orderable: false, targets: [3] }, { className: "hide_col", targets: [5] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Committee List',
          title: 'Committee List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 5],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          },

        }
      ]
    };


    this.committeeForm = new FormGroup({
      committeeName: new FormControl('', [Validators.required]),
      committeeAlias: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      CommitteeShortName: new FormControl('', []),
      otherCommitteeName: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator]),
      meetingFrequency: new FormControl('', [Validators.required, Validators.min(+1)]),
      meetingGap: new FormControl('', [Validators.min(+1)]),
      activationDate: new FormControl('', [Validators.required]),
      quorumDirectors: new FormControl('', [Validators.min(+1)]),
      meetingNoticePeriod: new FormControl('', [Validators.required]),
      charterUploadFile: new FormControl('', []),
      policies: new FormControl('', []),
      sittingFees: new FormControl('', []),
      statutoryCommittee: new FormControl('No', [Validators.required]),
      financialLiterate: new FormControl('No', []),
      accountingOrRelatedFinancialExpertise: new FormControl('No', [])
    });
    //this.setDefaultValues();
    // this.committeeForm.controls.statutoryCommittee.setValue("Yes");

    this.getInCorpDate()




  }

  roundDigit(val) {

    var str = new String(val);
    // console.log(val,'-----length',str.length);
    if (str.length == 1) {
      // console.log(parseInt(0+''+val));
      return (0 + '' + val);
    } else {
      return parseInt(val);
    }
  }

  ngAfterViewInit(): void {
    this.renderer.listen('document', 'click', (event) => {
      if (event.target.hasAttribute("update-committee")) {
        // console.log(event.target);
        this.showCommitteeUpdatePopUp(event.target.getAttribute("update-committee"))
      }
      if (event.target.hasAttribute("delete-committee")) {
        this.G_deletingID = event.target.getAttribute("delete-committee");
        $("#confirmation").modal('toggle');
      }

      if (event.target.hasAttribute("setup-committee")) {
        this.setUpCommitteePopUp(event.target.getAttribute("setup-committee"));
      }
    });

  }

  getInCorpDate() {
    this.dateOfIncorpOfCompany = "";
    this.committeeService.getInCorpDateOfCompany().subscribe(companyDateOfIncorp => {
      let dt = new Date(this.commonFunction.setFormatDate(companyDateOfIncorp.CompanyDetails[0].DateOfIncorporation))
      this.dateOfIncorpOfCompany = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      // console.log('companyDateOfIncorpcompanyDateOfIncorp--------------------------->>>>',this.dateOfIncorpOfCompany);
      let dt1 = new Date();
      this.futureDate = { month: dt1.getMonth() + 1, day: dt1.getDate(), year: dt1.getFullYear() }
    })
  }


  indexOfElementArray(array: any[], elementValue) {
    var index = _.findIndex(array, function (o) {
      return o.name == elementValue;
    })
    return index;
  }

  /*  
  * On Load To Get CommitteeList On Table
  */
  getCommitteeList() {
    this.committeeData = [];
    this.committeeNotSetUpList = [{ name: 'Audit Committee' },
    { name: 'Nomination & Remuneration Committee' },
    { name: 'Stakeholders Relationship Committee' },
    { name: 'CSR Committee' },
    { name: 'Risk Management Committee' }];


    this.committeeService.getCommitteeList()
      .subscribe(committee => {
        this.committeeData = [];
        if (committee.status == 0) {
          this.committeeData = committee.committeeList;
          for (var i = 0; i < this.committeeData.length; i++) {

            // console.log('available committee',this.committeeData[i].CommitteeName);
            if (this.committeeData[i].CommitteeName === 'Audit Committee') {

              var index = this.indexOfElementArray(this.committeeNotSetUpList, 'Audit Committee');
              this.committeeNotSetUpList.splice(index, 1);

            }
            if (this.committeeData[i].CommitteeName === 'Nomination & Remuneration Committee') {

              var index = this.indexOfElementArray(this.committeeNotSetUpList, 'Nomination & Remuneration Committee');
              this.committeeNotSetUpList.splice(index, 1);

            }
            if (this.committeeData[i].CommitteeName === 'Stakeholders Relationship Committee') {

              var index = this.indexOfElementArray(this.committeeNotSetUpList, 'Stakeholders Relationship Committee');

              this.committeeNotSetUpList.splice(index, 1);

            }
            if (this.committeeData[i].CommitteeName === 'CSR Committee') {
              var index = this.indexOfElementArray(this.committeeNotSetUpList, 'CSR Committee');
              this.committeeNotSetUpList.splice(index, 1);

            }
            if (this.committeeData[i].CommitteeName === 'Risk Management Committee') {

              var index = this.indexOfElementArray(this.committeeNotSetUpList, 'Risk Management Committee');
              // console.log('index--->',index);
              // console.log('this.committeeNotSetUpList',this.committeeNotSetUpList[index]);
              this.committeeNotSetUpList.splice(index, 1);
              // console.log('committeeNotSetupList--->',this.committeeNotSetUpList);


            }
          }

        }
        // console.log('committeeNotSetupList--->',committeeNotSetupList);
        this.dtTrigger.next();
        // console.log(this.committeeNotSetUpList);
      });
  }

  committeeIsAvailableInDB: boolean;
  otherCommitteeSelected: boolean;


  committeeChangeEventValidate(event) {

    var selectedCommitteeName = event.target.value;
    if (selectedCommitteeName == 'Other') {
      this.committeeForm.controls.statutoryCommittee.setValue('No');
    } else {
      this.committeeForm.controls.statutoryCommittee.setValue('Yes');
    }
    this.committeeForm.controls.otherCommitteeName.clearValidators();
    this.otherCommitteeSelected = false;
    this.IsAuditCommitteeSelected = false;
    this.committeeService.getCommitteeList().subscribe(committee => {
      if (committee.status == 0) {
        var localCommitteeData = []
        localCommitteeData = committee.committeeList;
        for (var i = 0; i < localCommitteeData.length; i++) {
          if (localCommitteeData[i].CommitteeName === selectedCommitteeName && selectedCommitteeName != 'Other') {

            //   console.log('available committee',this.committeeData[i].CommitteeName);
            this.committeeIsAvailableInDB = true;
            // this.committeeForm.controls.committeeName.
            break;
          } else {
            this.committeeIsAvailableInDB = false;
          }
        }
        if (selectedCommitteeName === 'Other') {

          this.committeeForm.controls.otherCommitteeName.setValidators([Validators.required, this.customValidation.noWhitespaceValidator]);
          this.committeeForm.controls.otherCommitteeName.updateValueAndValidity();
          this.otherCommitteeSelected = true;
        }
        if (selectedCommitteeName === 'Audit Committee') {
          this.IsAuditCommitteeSelected = true;
        }

      }
    });

  }


  settingAmount: any;
  warningALertForSettingAmount: any;
  escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  limitToAmount() {
    var amount = this.committeeForm.controls.sittingFees.value
    if (amount != "") {
      var amountWithoutComma = parseInt(amount.replace(new RegExp(this.escapeRegExp(','), 'g'), ''));
      if (amountWithoutComma <= 100000) {
        this.warningALertForSettingAmount = false;

      } else {
        this.warningALertForSettingAmount = true;
        this.committeeForm.controls.sittingFees.setErrors({ 'incorrect': true });
      }
    }

  }

  getCommitteeName() {
    this.committeeName = [
      { id: '0', name: 'Other', IsSelected: false },
      { id: '1', name: 'Audit Committee', IsSelected: false },
      { id: '2', name: 'CSR Committee', IsSelected: false },
      { id: '3', name: 'Nomination & Remuneration Committee', IsSelected: false },
      { id: '4', name: 'Risk Management Committee', IsSelected: false },
      { id: '5', name: 'Stakeholders Relationship Committee', IsSelected: false }
    ];
  }

  committeeDialogShowEvent() {
    this.committeeForm.controls.accountingOrRelatedFinancialExpertise.setValue('No');
    this.committeeForm.controls.financialLiterate.setValue('No');
    $('#committeeDialog').on('shown.bs.modal', function (e) {
      // $('#companytaskTable').DataTable().columns.adjust();
      $("#committeeName").focus()
    })
  }


  setUpCommitteePopUp(committeeName) {
    if (committeeName == 'Nomination') {
      committeeName = 'Nomination & Remuneration Committee'
    }
    if (committeeName == 'Risk') {
      committeeName = 'Risk Management Committee'
    }
    if (committeeName == 'Stakeholders') {
      committeeName = 'Stakeholders Relationship Committee'
    }
    if (committeeName == 'CSR') {
      committeeName = 'CSR Committee'
    }
    if (committeeName == 'Audit') {
      committeeName = 'Audit Committee'
    }

    this.committeeForm.controls.otherCommitteeName.clearValidators();
    this.otherCommitteeSelected = false;
    this.IsAuditCommitteeSelected = false;
    this.committeeForm.reset();
    this.committeeName = [];
    this.committeeName = [{ id: '1', name: committeeName, IsSelected: true },
    { id: '2', name: 'Other', IsSelected: false }];
    this.committeeForm.controls.statutoryCommittee.setValue('Yes');
    this.committeeForm.controls.committeeName.setValue(committeeName);
    this.committeeForm.controls.otherCommitteeName.clearValidators();
    if (committeeName == 'Audit Committee') {
      this.IsAuditCommitteeSelected = true;

    } else {
      this.IsAuditCommitteeSelected = false;
    }
    // setTimeout(function () {
    //   $("#committeeName").focus()
    // }, 100);
    this.committeeDialogShowEvent();
    $("#committeeDialog").modal('show');
    $('#btnsaveCommittee').show();
    $('#btnupdateCommittee').hide();
  }

  showCommitteePopUp() {
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#committeeDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#committeeDialog').modal('show');
    }, 100);
    this.committeeIsAvailableInDB = false;
    this.otherCommitteeSelected = true;
    this.committeeForm.reset();
    this.committeeForm.controls.committeeName.setValue('Other');
    this.committeeForm.controls.statutoryCommittee.setValue('No');
    this.committeeDialogShowEvent();
    this.getCommitteeName();
    $('#btnsaveCommittee').show();
    $('#btnupdateCommittee').hide();
  }



  charterfileArray: Array<File>;
  policiesfileArray: Array<File>;
  fileOrignalName: any;
  fileChangedName: any;

  charterfileChangeEvent(fileInput: any) {
    // this.charterfileArray = <Array<File>>fileInput.target.files;

    var checkfile = this.commonFunction.checkFileExtension(fileInput);
    if (checkfile) {
      this.charterfileArray = <Array<File>>fileInput.target.files;
      this.fileExtension = true;
    } else {
      this.fileExtension = false;
    }
  }

  policiesfileChangeEvent(fileInput: any) {
    // this.policiesfileArray = <Array<File>>fileInput.target.files;
    var checkfile = this.commonFunction.checkFileExtension(fileInput);
    if (checkfile) {
      this.policiesfileArray = <Array<File>>fileInput.target.files;
      this.changefileExtension = true;
    } else {
      this.changefileExtension = false;
    }
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        // this.fileOrignalName.push(files[i].name); // for multipule file upload make array of fileOrignalName
        this.fileOrignalName = files[i].name;

        formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
        // this.fileChangedName.push(newDate + '-' + files[i].name); // for multipule file upload make array of fileChangedName
        this.fileChangedName = newDate + '-' + files[i].name.replace(',', '');
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  upload(fileArray) {
    this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], fileArray).then((result) => {
      // console.log(result);
    }, (error) => {
      console.error(error);
    });
  }

  // isOtherNotValid:boolean;
  /*  
  * On click To Post Committee Data
  */
  addCommittee() {
    this.disabledOnclick = true;
    //File Uploadings

    let charterFileIsAvailable = false;
    let policiesFileIsAvailable = false;

    let charterFileChangedName = null;
    let charterFileOrignalName = null;

    let policiesFileChangedName = null;
    let policiesFileOrignalName = null;


    if (this.charterfileArray && this.policiesfileArray) {
      // console.log("available file", this.charterfileArray);
      // this.upload(this.charterfileArray);

      this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], this.charterfileArray).then((result) => {
        if (result) {
          charterFileIsAvailable = true;
          charterFileChangedName = this.fileChangedName;
          charterFileOrignalName = this.fileOrignalName;
          console.log(result);
          this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], this.policiesfileArray).then((result1) => {
            if (result1) {
              policiesFileIsAvailable = true;
              policiesFileChangedName = this.fileChangedName;
              policiesFileOrignalName = this.fileOrignalName;
              console.log(result1);
              if (this.committeeForm.status == 'VALID') {

                var newcommittee = {
                  otherCommitteeName: this.committeeForm.controls.otherCommitteeName.value,
                  committeeName: this.committeeForm.controls.committeeName.value,
                  committeeAlias: this.committeeForm.controls.committeeAlias.value,
                  CommitteeShortName: this.committeeForm.controls.CommitteeShortName.value,
                  meetingFrequency: this.committeeForm.controls.meetingFrequency.value,
                  meetingGap: this.committeeForm.controls.meetingGap.value,
                  activationDate: this.commonFunction.setDate(this.committeeForm.controls.activationDate.value),
                  quorumDirectors: this.committeeForm.controls.quorumDirectors.value,
                  meetingNoticePeriod: this.committeeForm.controls.meetingNoticePeriod.value,
                  sittingFees: this.committeeForm.controls.sittingFees.value,
                  statutoryCommittee: this.committeeForm.controls.statutoryCommittee.value,
                  charterFileIsAvailable: charterFileIsAvailable,
                  policiesFileIsAvailable: policiesFileIsAvailable,
                  charterFileChangedName: charterFileChangedName,
                  charterFileOrignalName: charterFileOrignalName,
                  policiesFileChangedName: policiesFileChangedName,
                  policiesFileOrignalName: policiesFileOrignalName,
                  accountingOrRelatedFinancialExpertise: this.committeeForm.controls.accountingOrRelatedFinancialExpertise.value,
                  financialLiterate: this.committeeForm.controls.financialLiterate.value,
                  CreatedBy: null,
                  CreatedDate: new Date(),
                  ModifiedBy: null,
                  ModifiedDate: new Date(),
                }

                if (newcommittee.committeeName == "Other") {
                  if (newcommittee.otherCommitteeName == "" || newcommittee.otherCommitteeName == null) {

                    return false;
                  } else {

                  }
                }

                this.committeeService.addCommittee(newcommittee).subscribe(commitee => {
                  this.disabledOnclick = false;
                  if (commitee.status == 0) {


                    this.alert.successWithOk1(commitee.message, () => {
                      $('#committeeDialog').off('hidden.bs.modal');
                      $('.modal-backdrop').remove();
                      $('body').removeClass('modal-open');
                    });
                    $('#committeeDialog').modal('hide');
                    this.committeeForm.reset();


                    var table = $('#committeeTable').DataTable({ destroy: true });
                    table.destroy();

                    this.getCommitteeList();
                  }
                  else {

                    if (commitee.err_fields != undefined && commitee.err_fields != "") {
                      this.alert.error(JSON.stringify(commitee.err_fields) + ' fields are required or invalid.');
                    } else {
                      this.alert.error1(commitee.message, () => {
                        $('#committeeDialog').off('hidden.bs.modal');
                        $('.modal-backdrop').remove();
                        $('body').removeClass('modal-open');
                      });
                    }
                    $('#committeeDialog').modal('hide');
                    this.changefileExtension = true;
                    this.fileExtension = true;
                  }

                });
              } else {
                this.disabledOnclick = false;
                return false;
              }
            }

          }, (error) => {
            console.error(error);
            return false;
          });
        }

      }, (error) => {
        console.error(error);
        return false;
      });

    } else if (this.charterfileArray) {

      this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], this.charterfileArray).then((result) => {
        if (result) {
          charterFileIsAvailable = true;
          charterFileChangedName = this.fileChangedName;
          charterFileOrignalName = this.fileOrignalName;
          console.log(result);
          if (this.committeeForm.status == 'VALID') {

            var newcommittee = {
              otherCommitteeName: this.committeeForm.controls.otherCommitteeName.value,
              committeeName: this.committeeForm.controls.committeeName.value,
              committeeAlias: this.committeeForm.controls.committeeAlias.value,
              CommitteeShortName: this.committeeForm.controls.CommitteeShortName.value,
              meetingFrequency: this.committeeForm.controls.meetingFrequency.value,
              meetingGap: this.committeeForm.controls.meetingGap.value,
              activationDate: this.commonFunction.setDate(this.committeeForm.controls.activationDate.value),
              quorumDirectors: this.committeeForm.controls.quorumDirectors.value,
              meetingNoticePeriod: this.committeeForm.controls.meetingNoticePeriod.value,
              sittingFees: this.committeeForm.controls.sittingFees.value,
              statutoryCommittee: this.committeeForm.controls.statutoryCommittee.value,
              charterFileIsAvailable: charterFileIsAvailable,
              policiesFileIsAvailable: policiesFileIsAvailable,
              charterFileChangedName: charterFileChangedName,
              charterFileOrignalName: charterFileOrignalName,
              policiesFileChangedName: policiesFileChangedName,
              policiesFileOrignalName: policiesFileOrignalName,
              accountingOrRelatedFinancialExpertise: this.committeeForm.controls.accountingOrRelatedFinancialExpertise.value,
              financialLiterate: this.committeeForm.controls.financialLiterate.value,
              CreatedBy: null,
              CreatedDate: new Date(),
              ModifiedBy: null,
              ModifiedDate: new Date(),
            }


            if (newcommittee.committeeName == "Other") {
              if (newcommittee.otherCommitteeName == "" || newcommittee.otherCommitteeName == null) {

                return false;
              } else {

              }
            }



            this.committeeService.addCommittee(newcommittee).subscribe(commitee => {
              this.disabledOnclick = false;
              if (commitee.status == 0) {

                this.alert.success(commitee.message);
                $('#committeeDialog').modal('toggle');
                this.committeeForm.reset();


                var table = $('#committeeTable').DataTable({ destroy: true });
                table.destroy();

                this.getCommitteeList();
              }
              else {

                if (commitee.err_fields != undefined && commitee.err_fields != "") {
                  this.alert.error(JSON.stringify(commitee.err_fields) + ' fields are required or invalid.');
                } else {
                  this.alert.error(commitee.message);
                }
                $('#committeeDialog').modal('toggle');
                this.changefileExtension = true;
                this.fileExtension = true;
              }

            });
          } else {

            this.disabledOnclick = false;
            return false;
          }
        }

      }, (error) => {
        console.error(error);
        return false;
      });

    } else if (this.policiesfileArray) {
      // console.log("available file", this.policiesfileArray);
      // this.upload(this.policiesfileArray)
      this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], this.policiesfileArray).then((result) => {
        if (result) {
          policiesFileIsAvailable = true;
          policiesFileChangedName = this.fileChangedName;
          policiesFileOrignalName = this.fileOrignalName;
          console.log(result);
          if (this.committeeForm.status == 'VALID') {

            var newcommittee = {
              otherCommitteeName: this.committeeForm.controls.otherCommitteeName.value,
              committeeName: this.committeeForm.controls.committeeName.value,
              committeeAlias: this.committeeForm.controls.committeeAlias.value,
              CommitteeShortName: this.committeeForm.controls.CommitteeShortName.value,
              meetingFrequency: this.committeeForm.controls.meetingFrequency.value,
              meetingGap: this.committeeForm.controls.meetingGap.value,
              activationDate: this.commonFunction.setDate(this.committeeForm.controls.activationDate.value),
              quorumDirectors: this.committeeForm.controls.quorumDirectors.value,
              meetingNoticePeriod: this.committeeForm.controls.meetingNoticePeriod.value,
              sittingFees: this.committeeForm.controls.sittingFees.value,
              statutoryCommittee: this.committeeForm.controls.statutoryCommittee.value,
              charterFileIsAvailable: charterFileIsAvailable,
              policiesFileIsAvailable: policiesFileIsAvailable,
              charterFileChangedName: charterFileChangedName,
              charterFileOrignalName: charterFileOrignalName,
              policiesFileChangedName: policiesFileChangedName,
              policiesFileOrignalName: policiesFileOrignalName,
              accountingOrRelatedFinancialExpertise: this.committeeForm.controls.accountingOrRelatedFinancialExpertise.value,
              financialLiterate: this.committeeForm.controls.financialLiterate.value,
              CreatedBy: null,
              CreatedDate: new Date(),
              ModifiedBy: null,
              ModifiedDate: new Date(),
            }


            if (newcommittee.committeeName == "Other") {
              if (newcommittee.otherCommitteeName == "" || newcommittee.otherCommitteeName == null) {

                return false;
              } else {

              }
            }



            this.committeeService.addCommittee(newcommittee).subscribe(commitee => {
              this.disabledOnclick = false;
              if (commitee.status == 0) {

                this.alert.success(commitee.message);
                $('#committeeDialog').modal('toggle');
                this.committeeForm.reset();

                var table = $('#committeeTable').DataTable({ destroy: true });
                table.destroy();

                this.getCommitteeList();
              }
              else {

                if (commitee.err_fields != undefined && commitee.err_fields != "") {
                  this.alert.error(JSON.stringify(commitee.err_fields) + ' fields are required or invalid.');
                } else {
                  this.alert.error(commitee.message);
                }
                $('#committeeDialog').modal('toggle');
                this.changefileExtension = true;
                this.fileExtension = true;
              }

            });
          } else {
            this.disabledOnclick = false;
            return false;
          }
        }

      }, (error) => {
        console.error(error);
        return false;
      });

    } else {
      if (this.committeeForm.status == 'VALID') {

        var newcommittee = {
          otherCommitteeName: this.committeeForm.controls.otherCommitteeName.value,
          committeeName: this.committeeForm.controls.committeeName.value,
          committeeAlias: this.committeeForm.controls.committeeAlias.value,
          CommitteeShortName: this.committeeForm.controls.CommitteeShortName.value,
          meetingFrequency: this.committeeForm.controls.meetingFrequency.value,
          meetingGap: this.committeeForm.controls.meetingGap.value,
          activationDate: this.commonFunction.setDate(this.committeeForm.controls.activationDate.value),
          quorumDirectors: this.committeeForm.controls.quorumDirectors.value,
          meetingNoticePeriod: this.committeeForm.controls.meetingNoticePeriod.value,
          sittingFees: this.committeeForm.controls.sittingFees.value,
          statutoryCommittee: this.committeeForm.controls.statutoryCommittee.value,
          charterFileIsAvailable: charterFileIsAvailable,
          policiesFileIsAvailable: policiesFileIsAvailable,
          charterFileChangedName: charterFileChangedName,
          charterFileOrignalName: charterFileOrignalName,
          policiesFileChangedName: policiesFileChangedName,
          policiesFileOrignalName: policiesFileOrignalName,
          accountingOrRelatedFinancialExpertise: this.committeeForm.controls.accountingOrRelatedFinancialExpertise.value,
          financialLiterate: this.committeeForm.controls.financialLiterate.value,
          CreatedBy: null,
          CreatedDate: new Date(),
          ModifiedBy: null,
          ModifiedDate: new Date(),
        }


        if (newcommittee.committeeName == "Other") {
          if (newcommittee.otherCommitteeName == "" || newcommittee.otherCommitteeName == null) {

            return false;
          } else {

          }
        }



        this.committeeService.addCommittee(newcommittee).subscribe(commitee => {
          this.disabledOnclick = false;
          if (commitee.status == 0) {


            this.alert.success(commitee.message);
            $('#committeeDialog').modal('toggle');
            this.committeeForm.reset();


            var table = $('#committeeTable').DataTable({ destroy: true });
            table.destroy();

            this.getCommitteeList();
          }
          else {

            if (commitee.err_fields != undefined && commitee.err_fields != "") {
              this.alert.error(JSON.stringify(commitee.err_fields) + ' fields are required or invalid.');
            } else {
              this.alert.error(commitee.message);
            }
            $('#committeeDialog').modal('toggle');
            this.changefileExtension = true;
            this.fileExtension = true;
          }

        });
      } else {

        this.disabledOnclick = false;
        return false;
      }
    }

  }//addCommittee


  /*  
  *On click To get Popup Data To Update
  */
  showCommitteeUpdatePopUp(committeeID) {
    // this.committeeForm.reset();

    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['committee', 'edit', committeeID] } }],
      { relativeTo: this.route.parent });
  }//Show Update Popup



  /*  
    *On Show POPUP To Visit Data in readonly 
    */
  showDisplayPopUp(committeeID) {

    this.committeeForm.reset();
    this.readonlyField = true;

    $('#btnsaveCommittee').hide();
    $('#btnupdateCommittee').hide();
    this.committeeService.getCommitteeById(committeeID)
      .subscribe(committee => {
        if (committee.status == 0) {

          this.committeeName = [
            { id: '1', name: committee.committeeData[0].CommitteeName, setDefaultValues: true },
          ];
          this.committeeId = committee._id;
          this.committeeForm.controls.committeeName.setValue(committee.committeeData[0].CommitteeName);
          this.committeeForm.controls.committeeAlias.setValue(committee.committeeData[0].CommitteeAlias);
          this.committeeForm.controls.CommitteeShortName.setValue(committee.committeeData[0].CommitteeShortName);
          this.committeeForm.controls.meetingFrequency.setValue(committee.committeeData[0].MeetingFrequencyInYear);
          this.committeeForm.controls.meetingGap.setValue(committee.committeeData[0].MeetingGaps);
          this.committeeForm.controls.quorumDirectors.setValue(committee.committeeData[0].QuorumNoofDirectors);
          this.committeeForm.controls.meetingNoticePeriod.setValue(committee.committeeData[0].NoticePeriodforMeeting);
          this.committeeForm.controls.statutoryCommittee.setValue(committee.committeeData[0].SatutoryCommittee);

        }
      });
  }

  /*  
    *On click To Show alert and Set _id to delete
    */
  showDeleteConfirmationPopUp(deletingID) {

  }


  /*  
    *On click To Final delete
    */
  deleteCommittee() {

    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.destroy();
    // });
    this.committeeService.deleteCommittee(this.G_deletingID).subscribe((data: any) => {
      if (data.status == 0) {
        this.alert.success(data.message);

        this.committeeForm.reset();
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next();
        });
        $('#confirmation').modal('toggle');
      }
      else {
        this.alert.error(data.message);

        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next();
        });
        $('#confirmation').modal('toggle');
      }
    });

  }
}
